import ListService from "../../src/Services/Shared/List.service";
export default class MeetingDependencies {
    // private readonly _resolvedItems: [string[], string[], string[], string[]];
    static getUnique(col, dependencies) {
        return ListService.unique(dependencies.map((row) => row[col]));
    }
    constructor(dependencies, search) {
        this._dependencies = dependencies;
        this._search = search;
        this._uniqueItems = [
            MeetingDependencies.getUnique(0, dependencies),
            MeetingDependencies.getUnique(1, dependencies),
            MeetingDependencies.getUnique(2, dependencies),
            MeetingDependencies.getUnique(3, dependencies),
            MeetingDependencies.getUnique(4, dependencies),
        ];
    }
    search(search) {
        var _a, _b, _c, _d;
        const searchArray = [
            search.people,
            (_a = search.offices) === null || _a === void 0 ? void 0 : _a.map((o) => o.toString()),
            (_b = search.offerings) === null || _b === void 0 ? void 0 : _b.map((o) => o.toString()),
            (_c = search.modalities) === null || _c === void 0 ? void 0 : _c.map((o) => o.toString()),
            (_d = search.campuses) === null || _d === void 0 ? void 0 : _d.map((o) => o.toString()),
        ];
        // return a new instance to avoid mutation
        return new MeetingDependencies(this._dependencies, searchArray);
    }
    resolve(col) {
        // This is a little tricky.  Let's say that Brent and Andrew both offer Advising, and we've selected Brent and Advising.
        // we still want Andrew to show up as a valid choice, because he also offers advising.  Therefore, for each dependency,
        // we look through all the *other* dependencies to find if this dependency has been filtered out.
        // If there isn't a search, we just return the unique items in this column:
        if (this._search == null) {
            return this._uniqueItems[col];
        }
        const definedSearch = this._search;
        // For each unique item that we have, we make sure that it's satisfied by the search.
        return this._uniqueItems[col].filter((id) => 
        // We need to make sure there's at least one row in the dependencies that has this id
        // and whose other fields are contained in the search, but first we limit the dependencies
        // to the ones that satisfy the unique items we're considering
        this._dependencies.some((dep) => dep[col] === id &&
            definedSearch.every((s, i) => i === col || s == null || s.length === 0 || s.includes(dep[i]))));
    }
    get people() {
        return this.resolve(0);
    }
    get offices() {
        return this.resolve(1).map((v) => parseInt(v, 10));
    }
    get offerings() {
        return this.resolve(2).map((v) => parseInt(v, 10));
    }
    get campuses() {
        return this.resolve(4).map((v) => parseInt(v, 10));
    }
    get modalities() {
        return this.resolve(3).map((v) => parseInt(v, 10));
    }
    isValid(validation) {
        return Object.values(validation).every((value) => value);
    }
    isInvalid() {
        const validation = this.validate();
        if (this.isValid(validation)) {
            return null;
        }
        return `There is no availability for your selection.`;
    }
    validate() {
        /*
         * Returns a boolean for each field, false meaning there are no options for this field the way the search is configured
         * (no dependencies returned when all other search values are used except that field)
         * If any field is false, no slots will be returned through the search. Formatted this way to make it easier to write
         * useful error messages, eg if people is false, it means there are no combinations of whatever is chosen for offices
         * offerings modality and campuses.
         * If people & offices are false, it means there is no combination of the other four options
         * for both, not necessarily just that there's no combination of campus, modality, and offering. This situation can
         * happen on deletes
         */
        return {
            staff: this.people.filter((x) => x != null).length !== 0,
            offices: this.offices.filter((x) => x != null).length !== 0,
            services: this.offerings.filter((x) => x != null).length !== 0,
            modalities: this.modalities.filter((x) => x != null).length !== 0,
            campuses: this.campuses.filter((x) => x != null).length !== 0,
        };
    }
}
